export const columnType = {
  REF_NUMBER: "id",
  REF_NUMBER_ONLY: "id",
  WMS_ORDER_NUMBER: "nota",
  ORDER_NUMBER: "orderNumber",
  NFE_NUMBER: "nfeNumber",
  NFE_SERIE: "nfeSerie",
  CREATE_DATE: "createdAt",
  DELIVERY: "deliveryDate",
  APPROVED_BY: "approvedBy",
  MATERIAL: "ordersMaterials",
  AGENT: "agent",
  PROMOTIONAL_CICLE: "promotionalCicle",
  STATUS: "status",
  STATUS_ERP: "ERPFileStatus",
  ACTION: "action",
  TYPE: "type",
  PRE_ORDER_QUANTITY: "preorderquantity",
};

export const columnLabel = {
  [columnType.REF_NUMBER]: "Ref. do pedido e Criação",
  [columnType.REF_NUMBER_ONLY]: "Ref. do pedido",
  [columnType.WMS_ORDER_NUMBER]: "Nota",
  [columnType.CREATE_DATE]: "Criação",
  [columnType.NFE_NUMBER]: "Nota fiscal cliente e Nº de série",
  [columnType.ORDER_NUMBER]: "Nº do pedido",
  [columnType.AGENT]: "Representante",
  [columnType.APPROVED_BY]: "Aprovado por",
  [columnType.STATUS]: "Status",
  [columnType.MATERIAL]: "Materiais",
  [columnType.PROMOTIONAL_CICLE]: "Ciclo Promocional",
  [columnType.DELIVERY]: "Data de Entrega",
  [columnType.STATUS_ERP]: "Status ERP",
  [columnType.TYPE]: "Tipo de produto",
  [columnType.PRE_ORDER_QUANTITY]: "Quantidade de pré-pedido",
};
